// src/features/home/components/RecommendedVideoListWideSection.js
import React, { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BsYoutube } from "react-icons/bs";

import "../../../shared/styles/RecommendedVideoList.css";

// 🔥 Firestore
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { db } from "../../../shared/libs/firebaseConfig";

import RecommendedVideoListWide from "../../articles/components/RecommendedVideoListWide";

export default function RecommendedVideoListWideSection() {
  const [allVideos, setAllVideos] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        setError("");

        const q = query(
          collection(db, "videos"),
          where("isActive", "==", true),
          orderBy("viewCounts", "desc"),
          limit(50)
        );

        const snap = await getDocs(q);

        const list = snap.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            title: data.title || "(ไม่มีชื่อวิดีโอ)",
            description: data.description || "",
            url: data.url || data.fileUrl || "",
            thumbUrl: data.thumbUrl || "",
            kind: data.kind || "youtube",
            categories: Array.isArray(data.categories) ? data.categories : [],
            createdAt: data.createdAt || null,
            updatedAt: data.updatedAt || null,
            viewCounts: typeof data.viewCounts === "number" ? data.viewCounts : 0,
          };
        });

        setAllVideos(list);
      } catch (err) {
        console.error("Recommended videos query failed:", err);
        setError(err?.message || "ไม่สามารถโหลดวิดีโอที่คุณอาจสนใจได้");
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const visibleVideos = useMemo(
    () => allVideos.slice(0, visibleCount),
    [allVideos, visibleCount]
  );

  const noMore = visibleCount >= allVideos.length || allVideos.length === 0;

  const handleLoadMore = () => setVisibleCount((prev) => prev + 4);

  return (
    <div className="mt-4 mb-4">
      <h3>
        <strong>
          <BsYoutube /> วิดีโอที่คุณอาจสนใจ
        </strong>
      </h3>

      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" role="status" />
        </div>
      )}

      {error && !loading && <div className="text-danger my-3">{error}</div>}

      {!loading && !error && visibleVideos.length > 0 && (
        <>
          <RecommendedVideoListWide videos={visibleVideos} />

          <div className="mt-4 mb-2 text-start">
            {noMore ? (
              <span style={{ color: "#777", fontSize: "18px" }}>
                ไม่มีวิดีโอเพิ่มเติม
              </span>
            ) : (
              <span onClick={handleLoadMore} className="load-more-link">
                ดูวิดีโอเพิ่มเติม
              </span>
            )}
          </div>
        </>
      )}

      {!loading && !error && visibleVideos.length === 0 && (
        <div className="text-muted my-3">ยังไม่มีวิดีโอแนะนำในขณะนี้</div>
      )}
    </div>
  );
}